<template>
    <div>
        <h1>
            Home adm
        </h1>


        <div class="row">
            <div class="col">
                <input type="text" placeholder="Cliente">
                <input type="password" placeholder="Senha">
            </div>
        </div>

        <div class="row">
            <div class="col">
                <button>
                    Cadastrar cliente
                </button>
            </div>
        </div>
    </div>
</template>

<script>
//Importação do utils.js
import * as utils from '../../../../utils.js';
import Swal from 'sweetalert2';

export default {
    name: "colabFoodAdmhome",

    data() {
        return {
            nomeCliente     : "",
            senhaCliente    : ""
        }
    },

    mounted() {
    },

    methods: {
        verificarSessaoAdm() {
            const codigo_usuarioHash = localStorage.getItem("codigo_usuario");

            if (utils.verificarHash(codigo_usuarioHash)) {
                //Luiz Trindade - Fazer uma requisição para verificar a sessão
                this.$http.post('https://grupo-colab.tech:8000/verificarsessao', {
                    codigo_usuario: codigo_usuarioHash
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    if (response.data == 0) {
                        //Luiz Trindade - Se a sessão for verdadeira, redirecionar para home
                        console.log("Usuário logado, redirecionando para home!");
                        this.$router.push("/services/colab-food/views/home");
                    } else {
                        //Se for um hash, mas o hash não for válido, permanece no login
                        console.log("Não está logado!");
                        utils.informar("Realize o login!");
                    }

                    utils.loader();
                })
                .catch(error => {
                    utils.loader();
                });
            } else {
                //Se não for um hash, permanece na tela de login
                console.log("Não está logado!");
                utils.informar("Realize o login!");
            }
        },

        cadastrarCliente() {
            utils.loader("start");

            this.$http.post('https://grupo-colab.tech:8000/registrar', {
                nome            : this.nomeCliente,
                senha           : this.senhaCliente,
                codigo_usuario  : utils.gerarHash(this.nomeCliente+senhaCliente)    
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if (response.data == "success") {
                    utils.informar("Cliente cadastrado com sucesso!");

                    this.nomeCliente    = "";
                    this.senhaCliente   = "";
                } else {
                    utils.informar("Erro ao cadastrar cliente!");
                }

                utils.loader();
            })
            .catch(error => {
                console.error('Erro ao cadastrar cliente:', error.response ? error.response.data : error.message);
                utils.loader();
            });
        },
    }
}
</script>

<style scoped>
</style>